import { useParams } from 'react-router-dom';
import { Loader } from '@mantine/core';
import { ProductList } from '@modules/products';
import { useFilterSet } from '@modules/filter-sets';
import { Breadcrumbs } from '@components';
import CollectionsPage from '../CollectionsPage/CollectionsPage';
import '@shared/styles/page.css';
import './FilterSetProductsPage.css';

export default function FilterSetProductsPage() {
    const { id } = useParams<{ id: string }>();
    const setId = id ? parseInt(id, 10) : undefined;

    // Хук должен вызываться до условного return (правила хуков React)
    const { data: filterSet, isLoading: filterSetLoading, error: filterSetError, refetch: refetchFilterSet } = useFilterSet(setId || 0);

    // Если нет ID, показываем страницу подборок
    if (!setId) {
        return <CollectionsPage />;
    }

    if (filterSetLoading) {
        return (
            <div className="page-container">
                <Breadcrumbs items={[
                    { label: 'Главная', path: '/' },
                    { label: 'Подборки', path: '/sets' },
                ]} />
                <div className="empty-container">
                    <Loader />
                </div>
            </div>
        );
    }

    if (!filterSet) {
        return (
            <div className="page-container">
                <Breadcrumbs items={[
                    { label: 'Главная', path: '/' },
                    { label: 'Подборки', path: '/sets' },
                ]} />
                <div className="empty-container">
                    <div>Подборка не найдена</div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-container">
            <Breadcrumbs items={[
                { label: 'Главная', path: '/' },
                { label: 'Подборки', path: '/sets' },
                { label: filterSet.title }
            ]} />

            <div className="page-header">
                <h1>{filterSet.title}</h1>
            </div>

            <div className="content-wrapper">
                <ProductList
                    products={filterSet.products || []}
                    isLoading={filterSetLoading}
                    error={filterSetError}
                    refetch={refetchFilterSet}
                    hideMenu={true}
                    emptyMessage="Товары не найдены"
                />
            </div>
        </div>
    );
}

